<template>
  <div class="mx-1 sm:mx-3 score rounded justify-center items-center inline-flex cursor-pointer"
       v-bind:class="getClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UserScore',
  props: {
    active: {
      default: false
    }
  },
  computed: {
    getClass () {
      return {
        'active': this.active
      }
    }
  }
}
</script>

<style scoped>
.score {
  --var-size: 45px;
  background: #F5F5F5;
  min-width: var(--var-size);
  max-width: var(--var-size);
  min-height: var(--var-size);
  max-height: var(--var-size);
  width: var(--var-size);
  height: var(--var-size);
  margin-top: 10px;
}

@media (min-width: 392px) {
  .score {
    --var-size: 50px;
    min-width: var(--var-size);
    max-width: var(--var-size);
    min-height: var(--var-size);
    max-height: var(--var-size);
    width: var(--var-size);
    height: var(--var-size);
  }
}

.score.active {
  background-color: var(--tus-green);
  color: white;
}
</style>
